import { render, staticRenderFns } from "./ed-task-board-group.component.vue?vue&type=template&id=3b77113a&scoped=true&"
import script from "./ed-task-board-group.component.ts?vue&type=script&lang=ts&"
export * from "./ed-task-board-group.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-task-board-group.component.scss?vue&type=style&index=0&id=3b77113a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b77113a",
  null
  
)

export default component.exports